// extracted by mini-css-extract-plugin
export default {"container":"WarehouseStat_container__HDtYf","ct-label":"WarehouseStat_ct-label__1njEu","header":"WarehouseStat_header__2ek1V"};